import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, Transition as _Transition } from "vue"
import _imports_0 from '@/assets/jengahills.jpeg'


const _hoisted_1 = { class: "bg-primary-800 shadow-md sticky top-0 z-50" }
const _hoisted_2 = { class: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" }
const _hoisted_3 = { class: "flex items-center justify-between h-16" }
const _hoisted_4 = { class: "hidden md:flex items-center gap-1" }
const _hoisted_5 = { class: "absolute top-full left-1/2 -translate-x-1/2 mt-1 w-[520px] bg-white rounded-2xl shadow-xl border border-secondary-200 p-5 z-50" }
const _hoisted_6 = { class: "grid grid-cols-2 gap-1 mb-4" }
const _hoisted_7 = { class: "text-sm font-medium text-primary-800" }
const _hoisted_8 = { class: "border-t border-secondary-200 pt-3" }
const _hoisted_9 = { class: "flex items-center gap-1" }
const _hoisted_10 = {
  key: 0,
  class: "absolute -top-0.5 -right-0.5 bg-accent-300 text-white text-xs font-bold rounded-full h-4 w-4 flex items-center justify-center leading-none"
}
const _hoisted_11 = {
  key: 0,
  class: "relative"
}
const _hoisted_12 = { class: "w-7 h-7 bg-accent-300 rounded-full flex items-center justify-center text-white text-xs font-bold" }
const _hoisted_13 = {
  key: 0,
  class: "absolute right-0 mt-2 w-48 bg-white rounded-xl shadow-lg py-1.5 z-50 border border-secondary-200"
}
const _hoisted_14 = { class: "px-4 py-2 border-b border-secondary-100" }
const _hoisted_15 = { class: "text-xs font-semibold text-primary-800" }
const _hoisted_16 = { class: "text-xs text-secondary-400 truncate" }
const _hoisted_17 = {
  key: 0,
  class: "w-5 h-5",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_18 = {
  key: 1,
  class: "w-5 h-5",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_19 = {
  key: 0,
  class: "md:hidden bg-primary-900 border-t border-primary-700"
}
const _hoisted_20 = { class: "px-4 py-3 space-y-1" }
const _hoisted_21 = { class: "pl-3 border-l-2 border-primary-700 ml-2 space-y-1" }
const _hoisted_22 = { class: "border-t border-primary-700 pt-2 mt-2 space-y-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: "/",
          class: "flex items-center gap-3 flex-shrink-0"
        }, {
          default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
            _createElementVNode("img", {
              src: _imports_0,
              alt: "Jenga Hills",
              class: "h-10 w-auto rounded"
            }, null, -1),
            _createElementVNode("span", { class: "hidden sm:block text-white font-bold text-lg tracking-tight leading-tight" }, " Jenga Hills ", -1)
          ]))]),
          _: 1
        }),
        _createElementVNode("nav", _hoisted_4, [
          _createVNode(_component_router_link, {
            to: "/",
            class: "nav-link",
            "exact-active-class": "nav-link-active"
          }, {
            default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
              _createTextVNode("Home", -1)
            ]))]),
            _: 1
          }),
          _createElementVNode("div", {
            class: "relative",
            onMouseenter: _cache[2] || (_cache[2] = ($event: any) => (_ctx.shopOpen = true)),
            onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (_ctx.shopOpen = false))
          }, [
            _createElementVNode("button", {
              class: _normalizeClass(["nav-link flex items-center gap-1", { 'nav-link-active': _ctx.isShopRoute }])
            }, [
              _cache[28] || (_cache[28] = _createTextVNode(" Shop ", -1)),
              (_openBlock(), _createElementBlock("svg", {
                class: _normalizeClass(["w-3.5 h-3.5 transition-transform", { 'rotate-180': _ctx.shopOpen }]),
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24"
              }, [...(_cache[27] || (_cache[27] = [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M19 9l-7 7-7-7"
                }, null, -1)
              ]))], 2))
            ], 2),
            _withDirectives(_createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (cat) => {
                  return (_openBlock(), _createBlock(_component_router_link, {
                    key: cat.id,
                    to: `/shop?category=${cat.slug}`,
                    class: "flex items-center gap-3 px-3 py-2.5 rounded-xl hover:bg-secondary-100 transition-colors group",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.shopOpen = false))
                  }, {
                    default: _withCtx(() => [
                      _cache[29] || (_cache[29] = _createElementVNode("div", { class: "w-8 h-8 bg-primary-800 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:bg-accent-300 transition-colors" }, [
                        _createElementVNode("svg", {
                          class: "w-4 h-4 text-white",
                          fill: "none",
                          stroke: "currentColor",
                          viewBox: "0 0 24 24"
                        }, [
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
                          })
                        ])
                      ], -1)),
                      _createElementVNode("span", _hoisted_7, _toDisplayString(cat.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_router_link, {
                  to: "/shop",
                  class: "flex items-center justify-center gap-2 w-full bg-primary-800 hover:bg-primary-700 text-white text-sm font-semibold py-2.5 rounded-xl transition-colors",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.shopOpen = false))
                }, {
                  default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                    _createTextVNode(" View All Products ", -1),
                    _createElementVNode("svg", {
                      class: "w-4 h-4",
                      fill: "none",
                      stroke: "currentColor",
                      viewBox: "0 0 24 24"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M17 8l4 4m0 0l-4 4m4-4H3"
                      })
                    ], -1)
                  ]))]),
                  _: 1
                })
              ])
            ], 512), [
              [_vShow, _ctx.shopOpen]
            ])
          ], 32),
          _createVNode(_component_router_link, {
            to: "/vendors",
            class: "nav-link",
            "active-class": "nav-link-active"
          }, {
            default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
              _createTextVNode(" Vendors ", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/about",
            class: "nav-link",
            "active-class": "nav-link-active"
          }, {
            default: _withCtx(() => [...(_cache[32] || (_cache[32] = [
              _createTextVNode(" About ", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/contact",
            class: "nav-link",
            "active-class": "nav-link-active"
          }, {
            default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
              _createTextVNode(" Contact ", -1)
            ]))]),
            _: 1
          }),
          (_ctx.isVendor && !_ctx.isAdmin)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: "/vendor",
                class: "nav-link",
                "active-class": "nav-link-active"
              }, {
                default: _withCtx(() => [...(_cache[34] || (_cache[34] = [
                  _createTextVNode("My Store", -1)
                ]))]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 1,
                to: "/admin",
                class: "nav-link",
                "active-class": "nav-link-active"
              }, {
                default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                  _createTextVNode("Admin", -1)
                ]))]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("button", {
            class: "p-2 text-secondary-200 hover:text-white transition-colors rounded-lg",
            "aria-label": "Search",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.push('/shop')))
          }, [...(_cache[36] || (_cache[36] = [
            _createElementVNode("svg", {
              class: "w-5 h-5",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [
              _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M21 21l-4.35-4.35M17 11A6 6 0 1 1 5 11a6 6 0 0 1 12 0z"
              })
            ], -1)
          ]))]),
          _createElementVNode("button", {
            class: "relative p-2 text-secondary-200 hover:text-white transition-colors rounded-lg",
            "aria-label": "Cart",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.store.dispatch('cart/toggleCart')))
          }, [
            _cache[37] || (_cache[37] = _createElementVNode("svg", {
              class: "w-5 h-5",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [
              _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M3 3h2l.4 2M7 13h10l4-8H5.4M7 13l-1.5 6h13M7 13L5.4 5M10 21a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm9 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"
              })
            ], -1)),
            (_ctx.cartCount > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.cartCount > 9 ? '9+' : _ctx.cartCount), 1))
              : _createCommentVNode("", true)
          ]),
          (_ctx.isAuthenticated)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("button", {
                  class: "flex items-center gap-2 text-secondary-200 hover:text-white transition-colors text-sm font-medium px-2 py-1 rounded-lg",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.userMenuOpen = !_ctx.userMenuOpen))
                }, [
                  _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.userInitial), 1),
                  (_openBlock(), _createElementBlock("svg", {
                    class: _normalizeClass(["w-3.5 h-3.5 transition-transform", { 'rotate-180': _ctx.userMenuOpen }]),
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24"
                  }, [...(_cache[38] || (_cache[38] = [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M19 9l-7 7-7-7"
                    }, null, -1)
                  ]))], 2))
                ]),
                (_ctx.userMenuOpen)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.currentUser?.name), 1),
                        _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.currentUser?.email), 1)
                      ]),
                      _createVNode(_component_router_link, {
                        to: "/profile",
                        class: "block px-4 py-2 text-sm text-primary-800 hover:bg-secondary-100",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.userMenuOpen = false))
                      }, {
                        default: _withCtx(() => [...(_cache[39] || (_cache[39] = [
                          _createTextVNode("My Profile", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(_component_router_link, {
                        to: "/orders",
                        class: "block px-4 py-2 text-sm text-primary-800 hover:bg-secondary-100",
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.userMenuOpen = false))
                      }, {
                        default: _withCtx(() => [...(_cache[40] || (_cache[40] = [
                          _createTextVNode("My Orders", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(_component_router_link, {
                        to: "/account/settings",
                        class: "block px-4 py-2 text-sm text-primary-800 hover:bg-secondary-100",
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.userMenuOpen = false))
                      }, {
                        default: _withCtx(() => [...(_cache[41] || (_cache[41] = [
                          _createTextVNode("Settings", -1)
                        ]))]),
                        _: 1
                      }),
                      (_ctx.isVendor && !_ctx.isAdmin)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            to: "/vendor",
                            class: "block px-4 py-2 text-sm text-primary-800 hover:bg-secondary-100",
                            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.userMenuOpen = false))
                          }, {
                            default: _withCtx(() => [...(_cache[42] || (_cache[42] = [
                              _createTextVNode("Vendor Dashboard", -1)
                            ]))]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.isAdmin)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 1,
                            to: "/admin",
                            class: "block px-4 py-2 text-sm text-primary-800 hover:bg-secondary-100",
                            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.userMenuOpen = false))
                          }, {
                            default: _withCtx(() => [...(_cache[43] || (_cache[43] = [
                              _createTextVNode("Admin Panel", -1)
                            ]))]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _cache[44] || (_cache[44] = _createElementVNode("hr", { class: "my-1 border-secondary-100" }, null, -1)),
                      _createElementVNode("button", {
                        class: "w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-red-50",
                        onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
                      }, "Sign Out")
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createVNode(_component_router_link, {
                  to: "/login",
                  class: "text-sm font-medium text-secondary-200 hover:text-white transition-colors px-3 py-1.5 rounded-lg"
                }, {
                  default: _withCtx(() => [...(_cache[45] || (_cache[45] = [
                    _createTextVNode(" Sign In ", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  to: "/register",
                  class: "text-sm font-medium bg-accent-300 hover:bg-accent-400 text-white px-4 py-1.5 rounded-lg transition-colors"
                }, {
                  default: _withCtx(() => [...(_cache[46] || (_cache[46] = [
                    _createTextVNode(" Register ", -1)
                  ]))]),
                  _: 1
                })
              ], 64)),
          _createElementVNode("button", {
            class: "md:hidden p-2 text-secondary-200 hover:text-white transition-colors rounded-lg ml-1",
            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.mobileMenuOpen = !_ctx.mobileMenuOpen)),
            "aria-label": "Menu"
          }, [
            (!_ctx.mobileMenuOpen)
              ? (_openBlock(), _createElementBlock("svg", _hoisted_17, [...(_cache[47] || (_cache[47] = [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M4 6h16M4 12h16M4 18h16"
                  }, null, -1)
                ]))]))
              : (_openBlock(), _createElementBlock("svg", _hoisted_18, [...(_cache[48] || (_cache[48] = [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M6 18L18 6M6 6l12 12"
                  }, null, -1)
                ]))]))
          ])
        ])
      ])
    ]),
    _createVNode(_Transition, { name: "slide-down" }, {
      default: _withCtx(() => [
        (_ctx.mobileMenuOpen)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_component_router_link, {
                  to: "/",
                  class: "mobile-link",
                  onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.mobileMenuOpen = false))
                }, {
                  default: _withCtx(() => [...(_cache[49] || (_cache[49] = [
                    _createTextVNode("Home", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  to: "/shop",
                  class: "mobile-link",
                  onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.mobileMenuOpen = false))
                }, {
                  default: _withCtx(() => [...(_cache[50] || (_cache[50] = [
                    _createTextVNode("Shop", -1)
                  ]))]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_21, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories.slice(0, 4), (cat) => {
                    return (_openBlock(), _createBlock(_component_router_link, {
                      key: cat.id,
                      to: `/shop?category=${cat.slug}`,
                      class: "block py-1.5 text-xs text-secondary-400 hover:text-white transition-colors",
                      onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.mobileMenuOpen = false))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(cat.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  }), 128))
                ]),
                _createVNode(_component_router_link, {
                  to: "/vendors",
                  class: "mobile-link",
                  onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.mobileMenuOpen = false))
                }, {
                  default: _withCtx(() => [...(_cache[51] || (_cache[51] = [
                    _createTextVNode("Vendors", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  to: "/about",
                  class: "mobile-link",
                  onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.mobileMenuOpen = false))
                }, {
                  default: _withCtx(() => [...(_cache[52] || (_cache[52] = [
                    _createTextVNode("About", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  to: "/contact",
                  class: "mobile-link",
                  onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.mobileMenuOpen = false))
                }, {
                  default: _withCtx(() => [...(_cache[53] || (_cache[53] = [
                    _createTextVNode("Contact", -1)
                  ]))]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_22, [
                  (_ctx.isAuthenticated)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: "/profile",
                        class: "mobile-link",
                        onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.mobileMenuOpen = false))
                      }, {
                        default: _withCtx(() => [...(_cache[54] || (_cache[54] = [
                          _createTextVNode("My Profile", -1)
                        ]))]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.isAuthenticated)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 1,
                        to: "/orders",
                        class: "mobile-link",
                        onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.mobileMenuOpen = false))
                      }, {
                        default: _withCtx(() => [...(_cache[55] || (_cache[55] = [
                          _createTextVNode("My Orders", -1)
                        ]))]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.isAuthenticated)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 2,
                        to: "/account/settings",
                        class: "mobile-link",
                        onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.mobileMenuOpen = false))
                      }, {
                        default: _withCtx(() => [...(_cache[56] || (_cache[56] = [
                          _createTextVNode("Settings", -1)
                        ]))]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.isVendor && !_ctx.isAdmin)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 3,
                        to: "/vendor",
                        class: "mobile-link",
                        onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.mobileMenuOpen = false))
                      }, {
                        default: _withCtx(() => [...(_cache[57] || (_cache[57] = [
                          _createTextVNode("My Store", -1)
                        ]))]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.isAdmin)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 4,
                        to: "/admin",
                        class: "mobile-link",
                        onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.mobileMenuOpen = false))
                      }, {
                        default: _withCtx(() => [...(_cache[58] || (_cache[58] = [
                          _createTextVNode("Admin", -1)
                        ]))]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}